import { render, staticRenderFns } from "./InstagramLogo.vue?vue&type=template&id=79d9ef52&"
import script from "./InstagramLogo.vue?vue&type=script&lang=js&"
export * from "./InstagramLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports